import {BuildInterfaceService} from 'dmmp-services'
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core'

@Component({
  selector: 'dmmp-event-location',
  templateUrl: './event-location.component.html'
})
export class EventLocationComponent implements OnInit {

  @Input() module: any
  @Input() detailLayout: any
  @Input() identifier: String
  @Input() defaultClass: String = 'event-information component-map'
  @Output() page = new EventEmitter()
  @Output() anchorCustom = new EventEmitter()
  mapsConfig: any
  marks: Array<any> = []
  @Input() pinUrl = './assets/images/house-pin.png'

  constructor(private buildInterfaceService: BuildInterfaceService) {
  }

  ngOnInit(): void {
    if (this.detailLayout) {
      this.mapsConfig = {
        center: {
          lat: this.detailLayout?.latitude ? parseFloat(this.detailLayout?.latitude) : (this.module?.maps_latitude ? this.module?.maps_latitude : 0),
          lng: this.detailLayout?.longitude ? parseFloat(this.detailLayout?.longitude) : (this.module?.maps_longitude ? this.module?.maps_longitude : 0)
        },
        zoom: this.module?.maps_zoom ? parseFloat(this.module?.maps_zoom) : 5 // Zoom default
      }

      this.marks.push(this.buildInterfaceService.buildMapMarkInterface(this.detailLayout, this.module?.maps_latitude, this.module?.maps_longitude, this.pinUrl))
    }
  }
}
